/*
 *  Mobile Carousels
 *    Scripts for the mobile css carousels
 *
 *  Version:
 *    1.0.0 - 2021/10/22
 */

import { responsiveMediaAbove } from '../../settings/responsive';
import { CLASS_ACTIVE, CLASS_INITIALISED } from '../../tools/constants/classes';

// Selectors
const SELECTOR_SCROLLER = '[data-mobile-scroller]';

document.querySelectorAll<HTMLElement>(SELECTOR_SCROLLER).forEach((element) => {
  if (element.classList.contains(CLASS_INITIALISED)) return;
  element.classList.add(CLASS_INITIALISED);

  let isDown = false;
  let startX: number;
  let scrollLeft: number;

  element.addEventListener('mousedown', (evt) => {
    if (responsiveMediaAbove('MEDIUM')) return;

    isDown = true;
    startX = evt.pageX - element.offsetLeft;
    scrollLeft = element.scrollLeft;
  });

  element.addEventListener('mouseleave', (evt) => {
    if (responsiveMediaAbove('MEDIUM')) return;

    isDown = false;
    element.classList.remove(CLASS_ACTIVE);
  });

  element.addEventListener('mouseup', (evt) => {
    isDown = false;
    element.classList.remove(CLASS_ACTIVE);
  });

  element.addEventListener('mousemove', (evt) => {
    if (responsiveMediaAbove('MEDIUM')) return;

    if (!isDown) return;
    element.classList.add(CLASS_ACTIVE);
    evt.preventDefault();
    const x = evt.pageX - element.offsetLeft;
    const walk = (x - startX) * 3;
    element.scrollLeft = scrollLeft - walk;
  });
});
